export function formatTrusteeReview(trusteeReview) {
  const re = /^- .*$/;
  const splitedText = trusteeReview.split("\n");
  let formatedText = splitedText.reduce((acc, line) => {
    if (re.test(line)) {
      let cleanLine = line.replace(/^-\s*/, "");
      if (Array.isArray(acc[acc.length - 1])) {
        acc[acc.length - 1].push(cleanLine);
      } else {
        acc.push([cleanLine]);
      }
    } else {
      acc.push(line);
    }
    return acc;
  }, []);
  return formatedText;
}
